import React from 'react';
import './app.css';

import AlbumGallery from './AlbumGallery';

function App() {
  return (
    <div className="app">
      <AlbumGallery/>
    </div>
  );
}

export default App;
